import { render, staticRenderFns } from "./rich-text.vue?vue&type=template&id=f7566674&scoped=true&"
import script from "./rich-text.vue?vue&type=script&lang=js&"
export * from "./rich-text.vue?vue&type=script&lang=js&"
import style0 from "./rich-text.vue?vue&type=style&index=0&id=f7566674&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7566674",
  null
  
)

export default component.exports